// Guard against sending PII as a Sentry user id. Rejects:
//  - emails (contain '@')
//  - bare-numeric ids of 6+ digits, ignoring space/hyphen separators
//    (Aadhaar 12, phone 10, bank account 9–18)
//  - Indian KYC document numbers by exact shape: PAN, passport, voter-ID / EPIC
// GlomoPay opaque ids pass: prefixed ids (cust_, kyc_, psess_, order_, …) and
// UUIDs contain '_' / hyphens / are longer, so they never match these anchored
// patterns — even when their hex-timestamp body has a digit run (e.g. `6af743563`).
const BARE_NUMERIC = /^\d{6,}$/; // Aadhaar / phone / bank account (separators stripped)
const PAN = /^[A-Z]{5}[0-9]{4}[A-Z]$/i; // e.g. ABCDE1234F
const PASSPORT = /^[A-Z][0-9]{7}$/i; // Indian passport, e.g. N1234567
const VOTER_ID = /^[A-Z]{3}[0-9]{7}$/i; // EPIC / voter-ID, e.g. ABC1234567

export const isPiiLikeUserId = (id: string): boolean => {
  if (id.includes('@')) return true;
  if (BARE_NUMERIC.test(id.replace(/[\s-]/g, ''))) return true;
  // KYC document numbers are tested against the raw id (not separator-stripped)
  // so a hyphenated opaque id can't collapse into a document shape.
  return PAN.test(id) || PASSPORT.test(id) || VOTER_ID.test(id);
};
